import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { services } from '../data/content';
import type { ServiceTier } from '../types/portfolio';
import { SectionHeading } from './SectionHeading';

type ServicesProps = {
  selectedTier: ServiceTier;
  onSelectTier: (tier: ServiceTier) => void;
};

export function Services({ selectedTier, onSelectTier }: ServicesProps) {
  const selectTier = (tier: ServiceTier) => {
    onSelectTier(tier);
    document.querySelector('#order')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="section-band" id="services">
      <div className="container">
        <SectionHeading
          eyebrow="Services"
          title="Service Categories"
          text="Site, Program, Game and State. Each category has several models in the checkout."
        />

        <div className="services-grid">
          {services.map((tier) => (
            <article
              className={`service-card reveal tone-${tier.accent} ${selectedTier.id === tier.id ? 'is-selected' : ''}`}
              key={tier.id}
            >
              <div className="service-head">
                <span>{tier.name}</span>
                <strong>{tier.price}</strong>
              </div>
              <p>{tier.delivery}</p>
              <ul>
                {tier.features.map((feature) => (
                  <li key={feature}>
                    <CheckCircle2 size={16} />
                    {feature}
                  </li>
                ))}
              </ul>
              <button className="btn btn-card" type="button" onClick={() => selectTier(tier)}>
                Order
                <ArrowRight size={17} />
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
